import { render } from "./TicksAction.vue?vue&type=template&id=3b7e4cdd&ts=true"
import script from "./TicksAction.vue?vue&type=script&lang=ts"
export * from "./TicksAction.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__